import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";
import type { UUID } from "@/core/types";

import { getPracticeName } from "../queryFunctions/getPracticeName";
import { timelineKeys } from "../keyFactory";

type UsePracticeNameProps<TData = string> = {
  practiceId: UUID | undefined;
  select?: (data: string) => TData;
};

type PracticeNameQueryOptions = UseQueryOptions<
  string,
  unknown,
  string,
  ReturnType<typeof timelineKeys.practiceName>
>;

function optionFactory(practiceId: UUID) {
  return {
    queryFn: () => getPracticeName(practiceId),
    queryKey: timelineKeys.practiceName(practiceId),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies PracticeNameQueryOptions;
}

export function usePracticeName<TData = string>({
  practiceId,
  select,
}: UsePracticeNameProps<TData>) {
  return useQuery({
    ...optionFactory(practiceId!),
    enabled: !!practiceId,
    select,
  });
}
